<div *ngFor="let dataGroup of chatdata.metadata;" class="row">
    <div *ngFor="let insight of dataGroup | keys let i = index" class="col-6 display-grid m-b-15">
        <div>
            <div class="product-panel__bg1">
                <div class="product_panel">
                    <a target="_blank" class="m-b-4" [href]="getInsightViewURLForHref(insight.ins_id, insight)" rel="noopener">
                        {{insight.ins_id}}
                    </a>
                    <h4>{{i+1}}. {{insight.title | slice:0:62}}{{insight.title.length > 62 ? '...' : '' }}</h4>
                </div>
                <div class="product_panel_body">
                    <p class="p-b-4" *ngIf="insight.ref_url">
                        <span>Reference: </span>
                        <ng-container *ngFor="let url of insight?.ref_url | refUrl let i = index">
                            <span *ngIf="i != 0">, </span>
                            <a [href]="url" target="_blank">Reference {{i+1}}</a>
                        </ng-container>
                    </p>
                    <p class="p-b-4" *ngIf="insight.attachment_name">
                        <span class="pull-left">Associated Documents :&nbsp; </span>
                        <ng-container *ngFor="let attach of insight?.attachment_name | attachmentName let att = index">
                            <div class="associate-doc-list">
                                <span *ngIf="att != 0">, </span>
                                <a (click)="viewFile(attach,'newTab',insight.ins_id)" rel="noopener"> Document {{att+1}} </a>
                                <a (click)="viewFile(attach,'sameTab',insight.ins_id)" class="ex_icon t-bottom t-sm" data-tooltip="Download" rel="noopener"> <em class="icon-download m-l-10"></em>
                                </a>
                                <a *ngIf="isDocChat" (click)="DocChat(attach,insight.ins_id)" class="ex_icon t-bottom t-sm" data-tooltip="Doc Chat" rel="noopener"> <em class="icon-chat m-l-10"></em>
                                </a>
                            </div>
                        </ng-container>
                    </p>
                    <br>
                    <p class="p-t-0" *ngIf="insight.countries">
                        <span>Markets: {{dataGroup.countries}}</span>
                        {{ displayCountries(insight.countries).firstTwo }}
                        <a class="hyperlink" *ngIf="displayCountries(insight.countries).remainingCount > 0" (click)="ShowRegulationMarkets(insight.countries, insight.ins_id, insight.title)">
                            +{{ displayCountries(insight.countries).remainingCount }}
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>